export default __webpack_public_path__ + "static/media/renter-steps-bg-mobile.28c79354.png";